import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../../../store/authSlice";
import { ROUTES } from "../../../utils/constants";

/**
 * @desc Handlers for login page.
 */
export const useHandlers = ({ setError, handleSubmit }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /**
   * @desc Dispatch login data.
   */
  const onSubmit = async (data) => {
    const response = await dispatch(login(data.password));
    if (login.fulfilled.match(response)) {
      navigate(ROUTES.ADMIN);
    } else if (login.rejected.match(response)) {
      setError("password", {
        type: "manual",
        message: response.payload.message,
      });
    }
  };

  /**
   * @desc On Enter key, submit login form.
   */
  const handleKeyUp = (e) => {
    switch (e.key) {
      case "Enter":
        handleSubmit(onSubmit)();
        break;
      default:
        break;
    }
  };

  return {
    handleKeyUp,
    onSubmit,
  };
};
